module.exports = __webpack_public_path__ + "img/background-dates.b54116e1.png";